import {Subscription} from "rxjs";
import {EventEmitter, Inject, Injectable} from "@angular/core";
import {AuthWellKnownEndpoints, OidcSecurityService, OpenIDImplicitFlowConfiguration} from "angular-auth-oidc-client";
import {AuthenticationService} from "../../../jpats/app/api/services/authentication.service";
import {filter, take, tap} from "rxjs/operators";

@Injectable()
export class ApiAuthService{
  isAuthorizedSubscription: Subscription;
  isAuthorized: boolean = false;
  authFinished: EventEmitter<any> = new EventEmitter<any>();
  showLocationSelect: EventEmitter<any> = new EventEmitter<any>();
  resetPatientSearch: EventEmitter<any> = new EventEmitter<any>();


  constructor(public oidcSecurityService: OidcSecurityService,
              private authenticateApi: AuthenticationService,
              @Inject('BASE_URL') baseUrl: string,
              @Inject('IDENTITY_URL') identityUrl: string ,
              @Inject('APP_NAME') private appName: string ){
    return;

  }

  private doCallbackLogicIfRequired() {
    if (typeof location !== "undefined" && window.location.hash) {
      this.oidcSecurityService.authorizedImplicitFlowCallback();

    }else{

    }
  }
  initiateLoginFlow(){
    this.oidcSecurityService.onAuthorizationResult.subscribe((res)=>{
    })
  }
  login() {
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.clearToken();

    this.oidcSecurityService.logoff();
  }

  hasAuthenticated() :boolean{

    return ((window.sessionStorage.getItem("_isAuthorized_" + this.appName)  || false )) as boolean;
  }
  ngOnDestroy(): void {
    if(this.isAuthorizedSubscription)
      this.isAuthorizedSubscription.unsubscribe();
    //if(this.oidcSecurityService.onModuleSetup)
    //this.oidcSecurityService.onModuleSetup.unsubscribe();
  }

  getServerToken(){
    let authResult =window.sessionStorage.getItem("authorizationResult_ndms");
    return JSON.parse(authResult || "{}").id_token || "";
  }
  setServerToken(token){
    window.sessionStorage.getItem("authorizationResult_ndms");
  }
  getUsername(): string {
    return JSON.parse(window.sessionStorage.getItem("userData_ndms") || "{}").name;
  }
  getToken(): string | null{
    return window.localStorage.getItem("token");
  }

  setToken(token:string){
    window.localStorage.setItem("token","Bearer " + token);
  }

  clearToken(){
    window.localStorage.removeItem("token");
  }

  authenticate(){
    return this.authenticateApi.RequestToken({stsJwt:this.getServerToken(),username:this.getUsername()});
  }

}
